import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { IAssessmentMessage } from "../shared/models/interfaces/assessment-message";
import { NgForm } from '@angular/forms';
import { AssessmentMessage } from "../shared/models/assessment-message.model";
import { takeUntil, catchError, tap } from 'rxjs/operators';
import { Subject, of, forkJoin } from 'rxjs';

@Component({
  selector: 'app-assessment-messages',
  templateUrl: './assessment-messages.component.html',
  styleUrls: ['./assessment-messages.component.scss']
})
export class AssessmentMessagesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() assessmentMessage: IAssessmentMessage | null;
  @Input() isEditMode: boolean;
  @Input() optionValueId: number;
  @Output() assessmentMessageAdded: EventEmitter<IAssessmentMessage> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (!this.isEditMode) {
      this.assessmentMessage = new AssessmentMessage(this.optionValueId);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  add(): void {
    if (this.assessmentMessage) {
      this.assessmentMessageAdded.emit(this.assessmentMessage);
    }
  }
}
